import { useAuth } from "@/shared/auth/useAuth";
import { Button } from "@/shared/components/ui/button";

export function ForbiddenPage() {
  const { signOut } = useAuth();
  return (
    <div
      data-testid="forbidden-screen"
      className="flex min-h-screen flex-col items-center justify-center gap-4 bg-ge-app p-6 text-center"
    >
      <h1 className="font-sans text-[24px] font-bold text-ge-primary">Access denied</h1>
      <p className="max-w-md text-[13px] text-ge-secondary">
        Your account doesn&apos;t have permission to view this. If you think this is a mistake,
        contact your tenant administrator.
      </p>
      <Button variant="outline" data-testid="forbidden-sign-out-button" onClick={() => void signOut()}>
        Sign out
      </Button>
    </div>
  );
}
